import React from 'react';

export default class ErrorBoundary extends React.Component<{ fallback?: React.ReactNode }, { hasError: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: any, info: any) {
    try {
      console.error('ErrorBoundary caught:', error, info);
    } catch {}
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <div className="p-4">Something went wrong.</div>;
    }
    return this.props.children as React.ReactNode;
  }
}
